import { cDisplay } from "../creator/cDisplay";
import { cGame } from "../creator/cGame";
import { cButton } from "../creator/cGameObjects/cButton";
import { cContainer } from "../creator/cGameObjects/cContainer";
import { cInlineDisplay } from "../creator/cGameObjects/cInlineDisplay";
import { cSprite } from "../creator/cGameObjects/cSprite";
import { cTextSprite } from "../creator/cGameObjects/cTextSprite";
import { cScene } from "../creator/cScene";
import { ScreenItem } from "../creator/dataTypes";

export class gameMagicDisplay extends cDisplay {
  private qData: any;
  private currentQuestion:any;
  private score: number = 0;
  private total: number;
  private cat: Cat;


  init() {
    super.init();

    var cS:cScene = this.scene as cScene;

    this.score = 0;

    var tt = this;

    (this.scene as cScene).ev.addListener("action", (command, options) => {

      switch (options.command) {
        case "next_question":
          this.currentQuestion = this.qData.pop();
          

          if (this.currentQuestion){
            cS.triggerSceneEvent('pull_card',{
              title: this.currentQuestion.question,
              label_1: this.currentQuestion.answer_1,
              label_2:this.currentQuestion.answer_2,
              label_3:this.currentQuestion.answer_3,
            });
          }else{
            var s = ['magic',this.score,this.total].join(':');
            console.log(s);
            cS.triggerSceneEvent('complted',{
              score: s
            });
          }
          break;
        case "pick":
          console.log('PICK',options, this.currentQuestion)
          if ( String(options.options) === String( this.currentQuestion.correct )){
            this.score++;
            cS.triggerSceneEvent('show_result',{
              card: options.options,
              correct: 1,
              texture: 'karte_ja.png' 
            });
          }else{
            cS.triggerSceneEvent('show_result',{
              card: options.options,
              correct: 0,
              texture: 'karte_nein.png' 
            });
          }
          break;
      }
    });
  }


  buildScene() {
    super.buildScene();
    var d = this.getByName('DATA') as cSprite
    this.qData = [...d.modules.data._extraData].sort(e=>Math.random() - 0.5);
    this.total = this.qData.length;

    var catHolder = this.getByName('cat_holder');
    this.cat = new Cat(this.scene,0,0);
    this.scene.add.existing(this.cat);
    catHolder.add(this.cat)
  }

  update(){
  }


  mounted() {
    
  }

  closed() {
    this.scene.events.off('update');
  }
}




class Cat extends Phaser.GameObjects.Container {

  private eye: Phaser.GameObjects.Sprite

  constructor(sc,x,y){
    super(sc,x,y);
    var cat = new Phaser.GameObjects.Sprite(sc,0,0,'magic_cat')
    cat.setOrigin(0.5,1);
    this.add( cat )

    this.eye = new Phaser.GameObjects.Sprite(sc,-7,-78,'magic_cat','cat_eyes_closed.png')
    this.eye.visible = false;
    this.add(this.eye);
  
    this.blink();
    this.popup();
  }


  popup(){
    if (!this.scene) return    
    this.y = 140;
    this.x = Math.floor( Math.random() * 1000 )
    this.scaleX = (this.x > 500) ? -1 : 1;    
    this.scene.tweens.add({
      targets:this,
      y:0,
      duration:400,
      onCompleted:()=>{
        var r = Math.random() * 100
        var s
        console.log(r)
        if (r < 30) {
          s = (this.scene as cScene).snd('audio_cat_1',{volume:0.3})
        }else if (r < 60) {
          s = (this.scene as cScene).snd('audio_cat_2',{volume:0.4})
        }

        setTimeout(()=>{ s && s.stop(); this.closePopup() },4000 + Math.random()* 2000)
      }
    })
  }

  closePopup(){
    if (!this.scene) return
    this.scene.tweens.add({
      targets:this,
      y:180,
      duration:400,
      onCompleted:()=>{
        setTimeout(()=>{ this.popup() },4000 + Math.random()* 2000)
      }
    })

  }


  blink(){
    this.eye.visible = false;
    setTimeout(()=>{
      this.eye.visible = true;
      setTimeout( ()=>{  
        this.blink() 
      }, 300 )

    }, 1000 + Math.floor( Math.random() * 2000))
  }


  update(){

    console.log('x');
  }

}